import { downloadPresentation } from '@utilities/powerpoint';

import { buildReportPresentation } from './buildReportPresentation';

export const downloadCurrentReportTab = async ({ customFileName, data, tabName }) => {
  const fileName = customFileName || data.exportName;
  const model = await buildReportPresentation({
    exportData: {
      ...data,
      tabsForExport: [{ tabId: data.tabId, tabName }],
    },
    fileName,
  });

  await downloadPresentation(model);
};
